import React, { ChangeEvent, FocusEvent } from 'react';
import { TextInput } from '../../../../ui/input/text_input/text_input';

interface InputProps {
  label?: string;
  type?: 'text' | 'email' | 'password' | 'number' | 'datetime-local' | string;
  placeholder?: string;
  required?: boolean;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  error?: boolean;
  helperText?: string;
}

export const FloatingLabelInput: React.FC<InputProps> = ({
  label,
  type = 'text',
  placeholder = '',
  required = false,
  value,
  onChange,
  onBlur,
  error = false,
  helperText = '',
}) => {
  return (
    <TextInput
      name={label ? label.toLowerCase().replace(/\s+/g, '_') : 'input'}
      label={label}
      type={type}
      placeholder={placeholder}
      required={required}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
    />
  );
};
